export default __webpack_public_path__ + "static/media/paymentimage.0466629b.svg";